var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPersonalMenuDetails(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 48,
    viewBox: "0 0 38 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.52 7.38013H34.86C35.76 7.38013 36.48 8.11012 36.48 9.00012V44.6101C36.48 45.5101 35.75 46.2301 34.86 46.2301H3.58997C2.68997 46.2301 1.96997 45.5001 1.96997 44.6101V9.00012C1.96997 8.10012 2.69997 7.38013 3.58997 7.38013H11.71",
    stroke: "#2E63EE",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.1599 5.77008C23.1599 3.60008 21.3999 1.84009 19.2299 1.84009C17.0599 1.84009 15.2999 3.60008 15.2999 5.77008H12.1499V11.04H26.3199V5.77008H23.1699H23.1599Z",
    stroke: "#2E63EE",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.98999 20.1201H27.7",
    stroke: "#2E63EE",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.98999 25.1901H27.7",
    stroke: "#2E63EE",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.98999 30.27H27.7",
    stroke: "#2E63EE",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M9.98999 35.3401H27.7",
    stroke: "#2E63EE",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2299 8.01013C20.097 8.01013 20.7999 7.30721 20.7999 6.44012C20.7999 5.57304 20.097 4.87012 19.2299 4.87012C18.3628 4.87012 17.6599 5.57304 17.6599 6.44012C17.6599 7.30721 18.3628 8.01013 19.2299 8.01013Z",
    fill: "#00C9B8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersonalMenuDetails);
export default __webpack_public_path__ + "static/media/personal-menu-details.262c56c3b954f34c0a0ef2966e74caa7.svg";
export { ForwardRef as ReactComponent };